export default __webpack_public_path__ + "static/media/product_bulk_upload_sample.d76ef188.csv";